import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SurveyEmoji3Props {
  color?: string;
  style?: React.CSSProperties;
}

export const SurveyEmoji3Icon = ({ color = RoutalPalette.white, style = {}, ...props }: SurveyEmoji3Props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 58 58" style={{ width: `58px`, height: `58px`, ...style }}>
      <circle cx="29.0664" cy="29.4209" r="15" fill="#FEC654" />
      <path
        d="M36.7734 19.8066C35.9189 19.2471 34.8954 19.0517 33.8945 19.2637C33.3534 19.3769 33.0078 19.9072 33.121 20.4472C33.2343 20.9892 33.7665 21.3339 34.3046 21.2206C34.7831 21.119 35.2704 21.2128 35.6786 21.4804C36.0878 21.7479 36.3681 22.1581 36.4687 22.6366C36.5673 23.1082 36.9833 23.4315 37.4462 23.4315C37.5146 23.4315 37.5829 23.4246 37.6523 23.41C38.1923 23.2967 38.539 22.7674 38.4257 22.2264C38.2167 21.2255 37.6298 20.3661 36.7734 19.8066ZM27.6816 21.3124C28.2167 21.454 28.7636 21.1356 28.9052 20.6025C29.0468 20.0693 28.7294 19.5215 28.1953 19.3789C26.1601 18.8398 24.0546 20.0546 23.5107 22.0927C23.3681 22.6268 23.6855 23.1746 24.2187 23.3162C24.3056 23.3397 24.3915 23.3504 24.4775 23.3504C24.9189 23.3504 25.3232 23.0555 25.4423 22.6083C25.7031 21.6347 26.706 21.0507 27.6816 21.3124ZM32.9999 27.404H28.9999C28.4472 27.404 27.9999 27.8512 27.9999 28.4039C27.9999 28.9566 28.4472 29.4039 28.9999 29.4039H32.9999C33.5527 29.4039 33.9999 28.9566 33.9999 28.4039C33.9999 27.8512 33.5527 27.404 32.9999 27.404Z"
        fill="#4D4D4D"
      />
      <path
        d="M27.5 26.4041C28.3284 26.4041 29 25.5087 29 24.4042C29 23.2997 28.3284 22.4043 27.5 22.4043C26.6716 22.4043 26 23.2997 26 24.4042C26 25.5087 26.6716 26.4041 27.5 26.4041Z"
        fill="#4D4D4D"
      />
      <path
        d="M34.502 26.4041C35.3304 26.4041 36.002 25.5087 36.002 24.4042C36.002 23.2997 35.3304 22.4043 34.502 22.4043C33.6735 22.4043 33.002 23.2997 33.002 24.4042C33.002 25.5087 33.6735 26.4041 34.502 26.4041Z"
        fill="#4D4D4D"
      />
    </SvgIcon>
  );
};
